import { useQuery } from '@tanstack/react-query';
import { GetAllNewsLetters } from '../api/api';

export const useNewsletters = () => {
  return useQuery({
    queryKey: ['newsletters'],
    queryFn: async () => {
      const { data, error } = await GetAllNewsLetters();
      if (error) throw new Error(error);
      return data;
    },
  });
};


